(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/iam-idp/assets/javascripts/react/components/bank-id/bank-id-start.js') >= 0) return;  svs.modules.push('/modules/iam-idp/assets/javascripts/react/components/bank-id/bank-id-start.js');

'use strict';

const {
  Button,
  ReactBank: Bank
} = svs.ui;
const {
  postMessageToParent
} = svs.iam_idp.utils;
const {
  PARENT_REDIRECT
} = svs.iam_idp.constants.POST_MESSAGE_TYPES;
const {
  Qr,
  SelectorButtons
} = svs.iam_idp.components.shared;
const {
  isPnp
} = svs.iam_idp.data;
const isMobile = svs.core.detect.formfactor.mobile();
const login = svs.iam_idp.utils.Login;
const {
  Loader
} = svs.components.ReactLoader;
const {
  useState
} = React;
const {
  useAtomValue
} = jotai;
const {
  activeMethodAtom
} = svs.iam_idp.atoms;
const BankIdStart = _ref => {
  let {
    showQR,
    isNewCustomer
  } = _ref;
  const activeMethod = useAtomValue(activeMethodAtom);
  const rawReturnUrl = svs.utils.url.queryString.returnUrl;
  const returnUrl = rawReturnUrl ? svs.utils.url.makeInternal(rawReturnUrl) : null;
  const [showAppLoader, setShowAppLoader] = useState(false);
  const handleClick = () => {
    if (showQR) {
      login.startBankIdSameDevice(isNewCustomer);
      setShowAppLoader(true);
    } else {
      login.start(activeMethod.isFreja, isNewCustomer);
    }
  };
  return React.createElement("div", null, showAppLoader ? React.createElement("div", {
    className: "spinner-container margin-bottom-1"
  }, React.createElement("p", {
    className: "spinner-container-text"
  }, "F\xF6rs\xF6ker starta BankID-appen"), React.createElement(Loader, null)) : React.createElement("div", null, React.createElement(SelectorButtons, null), showQR && React.createElement(Qr, {
    isNewCustomer: isNewCustomer,
    isPnp: isPnp
  }), React.createElement("div", {
    className: "login-buttons-container"
  }, React.createElement(Button, {
    block: true,
    className: "margin-top-1 margin-bottom-1",
    focus: isMobile,
    iconPosition: "left",
    inverted: true,
    onClick: handleClick,
    size: 300
  }, React.createElement(Bank, {
    height: 24,
    name: isPnp ? activeMethod.pnpIcon : activeMethod.icon
  }), showQR ? "Starta ".concat(activeMethod.methodName, " p\xE5 den h\xE4r enheten") : "Starta ".concat(activeMethod.methodName)))), React.createElement(Button, {
    block: true,
    className: "",
    inverted: isPnp,
    onClick: () => {
      postMessageToParent({
        value: returnUrl,
        type: PARENT_REDIRECT
      });
      setShowAppLoader(false);
    },
    size: 300,
    transparent: true
  }, "Avbryt"));
};
svs.iam_idp.components.bank_id.BankIdStart = BankIdStart;

 })(window);